module.exports = __webpack_public_path__ + "img/calendar4.188d1006.svg";